import { render, staticRenderFns } from "./TravelProgrammingSingleSelector.vue?vue&type=template&id=5971f8fa&scoped=true&"
import script from "./TravelProgrammingSingleSelector.vue?vue&type=script&lang=js&"
export * from "./TravelProgrammingSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971f8fa",
  null
  
)

export default component.exports